import {BellIconNotification} from "../../models/model"
import { Types }from '../action/action';

const initialState = {
    isBellNotify:false,
    chatBellNotification:[],
    callBellNotification:[],
    meetingBellNOtification:[],
    bellNotificationCount: 0
  };

  
  export const bellNotification = (state:BellIconNotification = initialState, action: any) => {
    const {
      type,
      payloads
    } = action;
    switch (type) {
    case Types.ISNOTIFY_STATUS:
    return {
      ...state, isBellNotify: payloads
    };
    case Types.CHAT_NOTIFICATIONS:
      return {
        ...state, chatBellNotification: payloads
      };
      case Types.CALL_NOTIFICATIONS:
      return {
        ...state, callBellNotification: payloads
      };
      case Types.MEETING_NOTIFICATIONS:
      return {
        ...state, meetingBellNOtification: payloads
      };

    case Types.BELL_NOTIFICATIONS_COUNT:
      return {
          ...state, bellNotificationCount: payloads
      };
   
    default:
      return state;
    };
  };